export const fontFamily = "Lato";
export const dFlex = { display: "flex", flexDirection: "row" };
export const dFlexC = { display: "flex", flexDirection: "column" };
export const flex1 = { flex: "1" };
export const division = {
  ...dFlex,
  flexDirection: "column",
  alignItems: "center",
  marginLeft: "1ch",
  textAlign: "center"
};
export const tableStyle = {
  width: "auto",
  whiteSpace: "nowrap",
  color: "#3A3A3A",
  marginBottom: "0.5em",
  marginRight: "0",
  marginLeft: "0",
  fontSize: "14px",
  textAlign: "right",
  fontWeight: "600",
  fontFamily
};
export const tableLabelStyle = {
  whiteSpace: "normal",
  fontFamily,
  fontSize: "20px",
  fontWeight: "bold",
  color: "#2F9CA3",
  textAlign: "left"
};
export const panelHeaderStyle = {
  fontSize: "20px",
  fontFamily,
  color: "#424242"
};
export const formulaStyle = sm => ({
  fontSize: sm ? "14px" : "16px",
  color: "#8F8F8F"
});
export const w100 = {
  width: "100%"
};
export const blueHeader = {
  fontFamily,
  fontStyle: "normal",
  fontWeight: "bold",
  lineHeight: "normal",
  fontSize: "24px",
  textAlign: "center",
  color: "#2F9CA3"
};



// WEBPACK FOOTER //
// ./src/components/analysis/styles.js